export default __webpack_public_path__ + "static/media/congris.e45f729f.png";